import { create } from 'zustand'

// ─── Feed audio store ───────────────────────────────────────────────────────
//
// "One unmuted video per screen" for the card/feed surfaces (Home, Posts,
// Weekly Cockpit), where many reels can autoplay (muted) at once. Holds the
// single currently-unmuted card; unmuting one card makes it the active one and
// every other card re-mutes. `null` = everything muted (the default).
//
// Distinct from the composer's per-post `preview-sound-store` (one video on
// screen, defaults to sound on). Not persisted — each session starts muted.

interface FeedAudioStore {
  /** Identity of the one card allowed to play sound, or null = all muted. */
  unmutedId: string | null
  setUnmuted: (id: string | null) => void
}

export const useFeedAudioStore = create<FeedAudioStore>(set => ({
  unmutedId: null,
  setUnmuted: id => set({ unmutedId: id }),
}))
